/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import { Form, FormGroup, ListGroup, ListGroupItem, Label, Input, Button } from "reactstrap";
import PropTypes from "prop-types";

import {
  PhysicalPersonRelationshipAccount,
  PhysicalPersonRelationshipAccountJuridical,
} from "../Person/types";
import { PersonType } from "./types";
import { SelectFormField } from "../../../utils/FormFields";

const BeneficiariesForm = ({
  holders,
  changedHolder,
  collapsedHolder,
  toggleHolder,
  onChange,
  account,
  existsMainHolder,
  handleDeleteHolder,
  role,
  isReadOnly,
}) => {
  const handleChangeInstruction = (name, value, index) => {
    onChange(index, name, value === "1");
  };

  return (
    <Form>
      <FormGroup tag="fieldset">
        <ListGroup>
          {holders.map((holder, index) => {
            const holderId = holder.AccountHolderId;
            const isMainHolder = changedHolder[holderId]
              ? changedHolder[holderId].isMainHolder
              : holder.IsMainHolder;
            const canBeMainHolder = (!existsMainHolder && !isMainHolder) || isMainHolder;
            const isController = changedHolder[holderId]
              ? changedHolder[holderId].HoldersIsController
              : holder.AccountHolderIsController;
            const isManager = changedHolder[holderId]
              ? changedHolder[holderId].HoldersIsManager
              : holder.AccountHolderIsManager;
            const accountRelationship = changedHolder[holderId]
              ? changedHolder[holderId].HoldersRelationship
              : holder.AccountHolderRelationship;
            const instructions = changedHolder[holderId]
              ? {
                  HoldersOrderManaged: changedHolder[holderId].HoldersOrderManaged,
                  HoldersOrderWeb: changedHolder[holderId].HoldersOrderWeb,
                  HoldersOrderWritten: changedHolder[holderId].HoldersOrderWritten,
                  HoldersOrderViaLink: changedHolder[holderId].HoldersOrderViaLink,
                }
              : {
                  HoldersOrderManaged: holder.HoldersOrderManaged,
                  HoldersOrderWeb: holder.HoldersOrderWeb,
                  HoldersOrderWritten: holder.HoldersOrderWritten,
                  HoldersOrderViaLink: holder.HoldersOrderViaLink,
                };
            return (
              <React.Fragment key={holderId}>
                <ListGroupItem
                  onClick={() => toggleHolder(index, true)}
                  style={{ cursor: "pointer", marginTop: 5, backgroundColor: "#607d8b" }}
                >
                  <Label
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      display: "block",
                    }}
                  >
                    {holder.AccountHolderName + " - Beneficiary Code " + holder.AccountBeneficiaryCode}
                    <div style={{ float: "right" }}>
                      {collapsedHolder[index].open ? (
                        <i className="fa fa-chevron-down" />
                      ) : (
                        <i className="fa fa-chevron-right" />
                      )}
                    </div>
                  </Label>
                </ListGroupItem>
                {collapsedHolder[index].open && (
                  <ListGroupItem>
                    <FormGroup>
                      <Label style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>
                        Holder Name:
                      </Label>
                      <Input value={holder.AccountHolderName} />
                    </FormGroup>
                    {role !== "Beneficiary" && (
                      <React.Fragment>
                        {holder.AccountHolderPersonType === PersonType.Physical ? (
                          <React.Fragment>
                            {account.AccountIsPhysical ? (
                              <React.Fragment>
                                <FormGroup>
                                  <Label style={{ fontWeight: 500, fontSize: "15px", display: "flex" }}>
                                    Account Relationship:
                                    <div
                                      style={{ marginLeft: 10 }}
                                      onClick={() => toggleHolder(index, false)}
                                    >
                                      {collapsedHolder[index].canEdit ? (
                                        <i className="fa fa-unlock" />
                                      ) : (
                                        <i className="fa fa-lock" />
                                      )}
                                    </div>
                                  </Label>
                                  <Input
                                    type="select"
                                    disabled={!collapsedHolder[index].canEdit}
                                    onChange={(e) => onChange(index, "HoldersRelationship", e.target.value)}
                                    value={accountRelationship}
                                  >
                                    {Object.keys(PhysicalPersonRelationshipAccount).map((key) => {
                                      if (
                                        isMainHolder &&
                                        PhysicalPersonRelationshipAccount[key] ===
                                          PhysicalPersonRelationshipAccount.Attorney
                                      ) {
                                        return null;
                                      }
                                      return (
                                        <option key={key} value={key}>
                                          {PhysicalPersonRelationshipAccount[key]}
                                        </option>
                                      );
                                    })}
                                  </Input>
                                </FormGroup>
                                <FormGroup>
                                  <Label
                                    check
                                    style={{ fontWeight: 500, fontSize: "15px", display: "block" }}
                                  >
                                    is Main Holder:
                                    <Input
                                      type="checkbox"
                                      style={{ marginLeft: 10 }}
                                      disabled={
                                        !collapsedHolder[index].canEdit ||
                                        !canBeMainHolder ||
                                        accountRelationship === PhysicalPersonRelationshipAccount.Attorney
                                      }
                                      defaultChecked={isMainHolder}
                                      value={isMainHolder}
                                      onClick={() => onChange(index, "isMainHolder", !isMainHolder)}
                                    />
                                  </Label>
                                </FormGroup>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <FormGroup>
                                  <Label style={{ fontWeight: 500, fontSize: "15px", display: "flex" }}>
                                    Account Relationship Juridical:
                                    <div
                                      style={{ marginLeft: 10 }}
                                      onClick={() => toggleHolder(index, false)}
                                    >
                                      {collapsedHolder[index].canEdit ? (
                                        <i className="fa fa-unlock" />
                                      ) : (
                                        <i className="fa fa-lock" />
                                      )}
                                    </div>
                                  </Label>
                                  <Input
                                    type="select"
                                    disabled={!collapsedHolder[index].canEdit}
                                    onChange={(e) =>
                                      onChange(index, "HoldersRelationshipJuridical", e.target.value)
                                    }
                                    value={
                                      changedHolder[holderId]
                                        ? changedHolder[holderId].HoldersRelationshipJuridical
                                        : holder.AccountHolderRelationshipJuridical
                                    }
                                  >
                                    {Object.keys(PhysicalPersonRelationshipAccountJuridical).map((key) => (
                                      <option key={key} value={key}>
                                        {PhysicalPersonRelationshipAccountJuridical[key]}
                                      </option>
                                    ))}
                                  </Input>
                                </FormGroup>
                                <FormGroup>
                                  <Label
                                    check
                                    style={{ fontWeight: 500, fontSize: "15px", display: "block" }}
                                  >
                                    Holder is Controller:
                                    <Input
                                      type="checkbox"
                                      style={{ marginLeft: 10 }}
                                      disabled={!collapsedHolder[index].canEdit}
                                      value={isController}
                                      onChange={() => onChange(index, "HoldersIsController", !isController)}
                                    />
                                  </Label>
                                </FormGroup>
                                <FormGroup>
                                  <Label
                                    check
                                    style={{ fontWeight: 500, fontSize: "15px", display: "block" }}
                                  >
                                    Holder is Manager:
                                    <Input
                                      type="checkbox"
                                      style={{ marginLeft: 10 }}
                                      disabled={!collapsedHolder[index].canEdit}
                                      value={isManager}
                                      onChange={() => onChange(index, "HoldersIsManager", !isManager)}
                                    />
                                  </Label>
                                </FormGroup>
                              </React.Fragment>
                            )}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <FormGroup>
                              <Label check style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>
                                is Main Holder:
                                <Input
                                  type="checkbox"
                                  style={{ marginLeft: 10 }}
                                  disabled
                                  defaultChecked={holder.IsMainHolder}
                                  value={holder.IsMainHolder}
                                />
                              </Label>
                            </FormGroup>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                    <FormGroup>
                      <Label style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>Email:</Label>
                      <Input value={holder.AccountHolderEmail} />
                    </FormGroup>
                    <FormGroup>
                      <Label style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>Phone:</Label>
                      <Input value={holder.AccountHolderTel} />
                    </FormGroup>
                    <FormGroup>
                      <Label style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>Address:</Label>
                      <Input value={holder.AccountHolderAddress} />
                    </FormGroup>
                    <FormGroup>
                      <Label style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>Country:</Label>
                      <Input value={holder.AccountHolderCountryName} />
                    </FormGroup>
                    <SelectFormField
                      label="Authorization Managed: "
                      value={instructions.HoldersOrderManaged ? "1" : "0"}
                      selectItems={[1, 0]}
                      disabled={account.AccountWayGiveOrders === "Managed"}
                      getSelectItemId={(i) => i}
                      getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
                      name="HoldersOrderManaged"
                      onChange={(name, value) => handleChangeInstruction(name, value, index)}
                    />
                    <SelectFormField
                      label="Authorization Written: "
                      value={instructions.HoldersOrderWritten ? "1" : "0"}
                      selectItems={[1, 0]}
                      getSelectItemId={(i) => i}
                      getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
                      disabled={instructions.HoldersOrderManaged}
                      name="HoldersOrderWritten"
                      onChange={(name, value) => handleChangeInstruction(name, value, index)}
                    />
                    <SelectFormField
                      label="Authorization Web: "
                      value={instructions.HoldersOrderWeb ? "1" : "0"}
                      selectItems={[1, 0]}
                      getSelectItemId={(i) => i}
                      getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
                      disabled={instructions.HoldersOrderManaged}
                      name="HoldersOrderWeb"
                      onChange={(name, value) => handleChangeInstruction(name, value, index)}
                    />
                    <SelectFormField
                      label="Authorization Via Link: "
                      value={instructions.HoldersOrderViaLink ? "1" : "0"}
                      selectItems={[1, 0]}
                      getSelectItemId={(i) => i}
                      getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
                      disabled={instructions.HoldersOrderManaged}
                      name="HoldersOrderViaLink"
                      onChange={(name, value) => handleChangeInstruction(name, value, index)}
                    />
                    {holder.AccountHolderPersonType === PersonType.Physical && (
                      <React.Fragment>
                        <FormGroup>
                          <Label style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>PEP?:</Label>
                          <Input value={holder.PEP ? "Yes" : "No"} />
                        </FormGroup>
                        {!isReadOnly && (
                          <Button onClick={() => handleDeleteHolder(holderId)}>
                            <i className="fa fa-trash" />
                            Remove Beneficiary
                          </Button>
                        )}
                      </React.Fragment>
                    )}
                  </ListGroupItem>
                )}
              </React.Fragment>
            );
          })}
        </ListGroup>
      </FormGroup>
    </Form>
  );
};

BeneficiariesForm.propTypes = {
  holders: PropTypes.array.isRequired,
  changedHolder: PropTypes.object.isRequired,
  collapsedHolder: PropTypes.array.isRequired,
  toggleHolder: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  account: PropTypes.object.isRequired,
  existsMainHolder: PropTypes.bool.isRequired,
  handleDeleteHolder: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
};

export default BeneficiariesForm;
